import { isNil } from 'lodash';

import StorefrontApi from 'api/Storefront';
import { SEARCH_OPERATIONS, SEARCH_QUERIES } from 'constants/storefront';

class StorefrontSearch {
  static search = async ({ queryToSearch, paginationPageSize, paginationNextCursor }) => {
    if (!Number.isInteger(paginationPageSize)) {
      throw new Error('Search query pagination page size is a numeric required value');
    }

    if (isNil(queryToSearch)) {
      throw new Error('Search query query to search is a required value');
    }

    if (!paginationNextCursor) {
      paginationNextCursor = null;
    }

    // Append exclusion filters to the query
    const modifiedQuery = `${queryToSearch} -tag:hidden -title:*returns*`.trim();

    const variables = { queryToSearch: modifiedQuery, paginationPageSize, paginationNextCursor };
    const gqlQuery = SEARCH_QUERIES.SEARCH_QUERY;
    const operationName = SEARCH_OPERATIONS.SEARCH;

    const { edges = [], totalCount } = await StorefrontApi.call({
      query: gqlQuery,
      variables,
      operationName,
    });

    // pull last item cursor for next page
    const lastItemCursor = edges?.slice(-1)[0]?.cursor;

    return {
      searchItems: edges,
      searchTotalItems: totalCount,
      paginationNextCursor: lastItemCursor,
    };
  };
}

export default StorefrontSearch;
